import { css, Interpolation, Theme } from '@emotion/react'

export const actionsHeader: Interpolation<Theme> = css`
  width: 48px;
  padding: 0;
  background: none;
  border: none;
  box-shadow: none;
`

export const actionsCell: Interpolation<Theme> = css`
  width: 48px;
  padding: 0;
  vertical-align: middle;
`

export const removeButton: Interpolation<Theme> = (theme) => css`
  &.MuiButtonBase-root {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }

    &.Mui-disabled {
      svg path {
        stroke: ${theme.typographyColors.typographyFour};
      }
    }
  }
`
